<template>
  <div class="Crmactivemanage-crmAdmissionList">
    <PageNav>
      <div id="page-crmAdmissionList">
        <div class="head-tab--nav">
          <div class="head-nav h-3 clearFloat">
            <span class="c-normal">{{ $t("Crmactivemanage.bs") }}</span>
            <div class="pull-right">
              <!-- <el-button type="warning" @click="handAdd()">生成名单</el-button> -->
              <el-button type="primary" @click="daochu">{{
                $t("Crmactivemanage.by")
              }}</el-button>
            </div>
          </div>
        </div>
        <div class="crmAdmissionList-container">
          <div class="content">
            <div class="flex-wrap">
              <div class="flex-al mb20 mr10">
                <span class="mr10 fs14 color-666">{{
                  $t("Crmactivemanage.bt")
                }}</span>
                <div class="select-box" style="width:170px;">
                  <el-select
                    v-model="selectForm.freevoucher_name"
                    clearable
                    filterable
                    :placeholder="$t('Crmactivemanage.bu')"
                    @change="handleSelect()"
                  >
                    <el-option
                      :label="$t('Crmactivemanage.ak')"
                      value
                    ></el-option>
                    <el-option
                      v-for="(item, index) in nameList"
                      :key="index"
                      :label="item.freevoucher_name"
                      :value="item.freevoucher_name"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="flex-al Inquire-box mb20">
                <div class="ipt-box">
                  <el-input
                    v-model="selectForm.keyword"
                    class="input-cont"
                    clearable
                    style="width:260px"
                    :placeholder="$t('Crmactivemanage.bv')"
                    @change="handleSelect()"
                  ></el-input>
                </div>
                <el-button
                  type="primary"
                  class="btn-inquire fs14"
                  @click="handleSelect()"
                  >{{ $t("Crmactivemanage.as") }}</el-button
                >
              </div>
            </div>
            <div class="tableDiv" ref="auto_height_table">
              <normalTableCont
                :tableData="tableList"
                @handSetting="handSetting"
              ></normalTableCont>
              <!-- 分页 -->
              <el-pagination
                style="margin: 10px;"
                :current-page.sync="paging.curPage"
                :page-sizes="[10, 20, 30, 40]"
                :page-size.sync="paging.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="paging.pageTotal"
                @current-change="curPageChange"
                @size-change="pageSizeChange"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </PageNav>
  </div>
</template>
<script>
import PageNav from "../../components/Nav/nav.vue";
import normalTableCont from "../../components/tables/normalTableCont.vue";
import CrmActiveManage from "../Crmactivemanage/crmActiveManage.js";

export default {
  name: "Crmactivemanage-crmAdmissionList",
  data() {
    return {
      basicinformation: [],
      dialogimgVisible: false,
      activityId: "", //暂存查看的活动id
      //筛选条件--名单管理
      selectForm: {
        freevoucher_name: "",
        keyword: ""
      },
      nameList: [], //招生劵名称列表
      // 表格数据
      tableList: {
        // 表格的列
        columns: [],
        // 表格数据
        list: [],
        options: {
          errortip: "", //空页面提示内容
          mutiSelect: false, //是否显示多选
          issetting: false, //是否可以编辑列
          tableHeight: 0
        }
      },
      // 分页
      paging: {
        curPage: 1,
        pageSize: 10,
        pageTotal: 10
      }
    };
  },
  components: {
    PageNav,
    normalTableCont
  },
  updated() {},
  created() {
    this.token = this.$store.state.USER_TOKEN;
    this.marketer_id = this.$store.state.MARKETER_ID;
    this.school_id = this.$store.state.SCHOOL_ID;
    this.company_id = this.$store.state.COMPANY_ID;
    // 权限判断
    this.postbe_crmlevel = this.$store.state.POSTBE_CRMLEVEL;
    this.activity_id = this.$route.query.id;
    this.freevoucherList(); //名单管理
  },
  computed: {},
  methods: {
    //名单管理
    freevoucherList() {
      CrmActiveManage.freevoucherList({
        activity_id: this.activity_id,
        school_id: this.school_id,
        import: this.import,
        p: this.paging.curPage,
        num: this.paging.pageSize,
        is_count: "1", //是否需要总数，可以不传
        //筛选条件
        keyword: this.selectForm.keyword,
        freevoucher_name: this.selectForm.freevoucher_name //招生券名称
      }).then(res => {
        this.tableList.columns = res.data.data.field;
        this.paging.pageTotal = parseInt(res.data.data.all_num);
        this.nameList = res.data.data.name;
        this.tableList.options.errortip = res.data.msg;
        if (res.data.code === 200) {
          this.tableList.list = res.data.data.list;
        } else {
          this.tableList.list = [];
        }
      });
    },
    // 选择单个活动名单
    handleSelect() {
      this.paging.curPage = 1;
      this.freevoucherList();
    },
    // 编辑列编辑提交
    handSetting(v) {
      (() => {})(v);
    },
    // 页码变化
    curPageChange(v) {
      this.paging.curPage = v;
      this.freevoucherList();
    },
    // pageSize改变
    pageSizeChange() {
      this.paging.curPage = 1;
      this.freevoucherList();
    },
    handleClose(done) {
      done();
    },
    // 导出操作
    daochu() {
      let url = CrmActiveManage.freevoucherList1();
      var is_import = 1;
      let language_type = this.$Tool.getStorage("language")
        ? this.$Tool.getStorage("language")
        : "zh";
      (() => {})(
        `${url}?marketer_id=${this.marketer_id}&token=${this.token}&activity_id=${this.activity_id}&school_id=${this.school_id}&company_id=${this.company_id}&import=${is_import}&keyword=${this.selectForm.keyword}&freevoucher_name=${this.selectForm.freevoucher_name}&language_type=${language_type}`
      );
      if (this.tableList.list.length > 0) {
        window.open(
          this.$buildExportUrl(`${url}?marketer_id=${this.marketer_id}&token=${this.token}&activity_id=${this.activity_id}&school_id=${this.school_id}&company_id=${this.company_id}&is_export=${is_import}&keyword=${this.selectForm.keyword}&freevoucher_name=${this.selectForm.freevoucher_name}&language_type=${language_type}`),
          "_blank"
        );
      } else {
        this.$message.error(this.$t("Crmactivemanage.cm"));
      }
    }
  },

  mounted() {
    this.$nextTick(() => {
      if (this.$refs["auto_height_table"]) {
        this.tableList.options.tableHeight = this.$Common.getTableHeight(
          this.$refs.auto_height_table.getBoundingClientRect().top + 95
        );
      }
    });
  }
};
</script>
<style lang="less">
@import url("../../assets/less/manage.less");
@import url("crmActiveManage.less");
.Crmactivemanage-crmAdmissionList {
  height: 100vh;
  font-size: 14px;
  .tan-code {
    .code {
      text-align: center;
      width: 70%;
      margin: 0 auto;
      img {
        display: block;
        width: 100%;
        margin: 0 auto;
      }
      p {
        margin-top: 20px;
        margin-bottom: 20px;
      }
    }
    .el-dialog__header {
      display: none;
    }
    .el-dialog {
      margin-top: 24vh;
    }
  }
  .code {
    width: 200px;
    text-align: center;
    margin: 20px auto;
    img {
      width: 100%;
    }
  }
}
</style>
